export default {
  recipeCard: {
    card: { padding: 15 }
  }
}
